import { LICENSE_CODES } from "./LicenseStateParsers/LicenseCodes";

const FIXED_BYTES = 21;
const SUBFILE_BYTES = 10;
const DL_BYTES = 2;
const NUM_ENTRIES_START = 19;
const NUM_ENTRIES_END = 21;
const OLD_FL_CORRECTION = -2;
const IIN_START = 9;
const IIN_END = 15;

export const licenseParser = async str => {
  if (str.charAt(0) !== "@") {
    console.error(
      "Incorrect Compliance Indicator. Please clear the field and try scanning the barcode again."
    );
    return;
  }

  if (str.startsWith("@") && str.includes("ANSI")) {
    str = str.replace(/@(?![\s\S]{3}ANSI)([\s\S]*?)ANSI/, "@\n\r\rANSI");
  }
  const dataElementSeparator = str.charAt(1);
  const segmentTerminator = str.charAt(3);

  let numEntriesStart = NUM_ENTRIES_START;
  let numEntriesEnd = NUM_ENTRIES_END;
  let dlBytes = DL_BYTES;
  const iin = str.slice(IIN_START, IIN_END);
  if (+iin === 636010 && str.slice(19, 21) === "DL") {
    numEntriesStart += OLD_FL_CORRECTION;
    numEntriesEnd += OLD_FL_CORRECTION;
    dlBytes += OLD_FL_CORRECTION;
    console.log("Old FL license detected. Adjusting bytes.");
  }
  const number_of_entries = str.slice(numEntriesStart, numEntriesEnd);
  const federalStartingIndex =
    FIXED_BYTES + +number_of_entries * SUBFILE_BYTES + dlBytes;
  //The first 21 bytes are fixed then each subfile designator is 10 bytes then 2 additional bytes for the "DL"

  //Original method
  // const federalEndingIndex = str.lastIndexOf('\r')
  // const federalTrimmedStr = federalEndingIndex > federalStartingIndex ? str.slice(federalStartingIndex, federalEndingIndex) : str.slice(federalStartingIndex)
  // const federalArr = federalTrimmedStr.split('\n')

  //Break the entire string on /r
  const encoding = str.slice(federalStartingIndex);
  const encodingArr = encoding.split(segmentTerminator);
  const federalArr = encodingArr[0].split(dataElementSeparator);
  // const stateArr = encodingArr?.[1]?.split(dataElementSeparator)

  //Later add the state subfiles in here and pass them to create person
  return { federalArr, iin };
};

export function cleanupValue(str) {
  //strips trailing commas and whitespace
  //add an if clause to check if str is a string, if not return str
  if (typeof str !== "string") return str;
  return str?.replace(/[, ]+$/, "")?.trim() || str;
}

export function createPersonFromScan(federalArr, iin, stateArr) {
  let personObj = {};
  let iinInfo = IIN_LOOKUP.find(i => i?.iin?.toString() === iin?.toString());
  let state = iinInfo.state;
  let stateAbbr = iinInfo.abbr;

  federalArr?.forEach(i => {
    let code = i.slice(0, 3);
    let value = cleanupValue(i.slice(3));
    let name = LICENSE_CODES["FEDERAL"] ? LICENSE_CODES["FEDERAL"][code] : code;
    personObj[name] = value !== "NONE" ? value : "";
  });
  //This doesn't do anything yet
  stateArr?.forEach(i => {
    let code = i.slice(0, 3);
    let value = cleanupValue(i.slice(3));
    let name = LICENSE_CODES[state] ? LICENSE_CODES[state][code] : code;
    personObj[name] = value;
  });
  personObj["iin"] = iinInfo;

  if (personObj["fullName"]) {
    console.log("FL full name found", personObj["fullName"]);
    const nameArr = personObj["fullName"].split(",");
    personObj["firstName"] = cleanupValue(nameArr[1]);
    personObj["lastName"] = cleanupValue(nameArr[0]);
    personObj["middleName"] = cleanupValue(nameArr[2]);
  }

  if (personObj["firstMiddle"]) {
    console.log("NY DCT code found", personObj["firstMiddle"]);
    const nameArr = personObj["firstMiddle"].split(",");
    personObj["firstName"] = cleanupValue(nameArr[0]);
    personObj["middleName"] = nameArr[1]
      ? cleanupValue(nameArr[1])
      : cleanupValue(personObj?.["middleName"]);
  }

  if (iinInfo.country === "CANADA") {
    personObj["state"] = stateAbbr;
  }

  return personObj;
}

const IIN_LOOKUP = [
  {
    iin: 636033,
    state: "Alabama",
    abbr: "AL",
    country: "USA",
  },
  {
    iin: 636059,
    state: "Alaska",
    abbr: "AK",
    country: "USA",
  },
  {
    iin: 604432,
    state: "Alberta",
    abbr: "AB",
    country: "CANADA",
  },
  {
    iin: 604427,
    state: "American Samoa",
    abbr: "AS",
    country: "USA",
  },
  {
    iin: 636026,
    state: "Arizona",
    abbr: "AZ",
    country: "USA",
  },
  {
    iin: 636021,
    state: "Arkansas",
    abbr: "AR",
    country: "USA",
  },
  {
    iin: 636028,
    state: "British Columbia",
    abbr: "BC",
    country: "CANADA",
  },
  {
    iin: 636014,
    state: "California",
    abbr: "CA",
    country: "USA",
  },
  {
    iin: 636056,
    state: "Coahuila",
    abbr: "CU",
    country: "MEXICO",
  },
  {
    iin: 636020,
    state: "Colorado",
    abbr: "CO",
    country: "USA",
  },
  {
    iin: 636006,
    state: "Connecticut",
    abbr: "CT",
    country: "USA",
  },
  {
    iin: 636011,
    state: "Delaware",
    abbr: "DE",
    country: "USA",
  },
  {
    iin: 636043,
    state: "District of Columbia",
    abbr: "DC",
    country: "USA",
  },
  {
    iin: 636010,
    state: "Florida",
    abbr: "FL",
    country: "USA",
  },
  {
    iin: 636055,
    state: "Georgia",
    abbr: "GA",
    country: "USA",
  },
  {
    iin: 636019,
    state: "Guam",
    abbr: "GU",
    country: "USA",
  },
  {
    iin: 636047,
    state: "Hawaii",
    abbr: "HI",
    country: "USA",
  },
  {
    iin: 636057,
    state: "Hidalgo",
    abbr: "HL",
    country: "MEXICO",
  },
  {
    iin: 636050,
    state: "Idaho",
    abbr: "ID",
    country: "USA",
  },
  {
    iin: 636035,
    state: "Illinois",
    abbr: "IL",
    country: "USA",
  },
  {
    iin: 636037,
    state: "Indiana",
    abbr: "IN",
    country: "USA",
  },
  {
    iin: 636018,
    state: "Iowa",
    abbr: "IA",
    country: "USA",
  },
  {
    iin: 636022,
    state: "Kansas",
    abbr: "KS",
    country: "USA",
  },
  {
    iin: 636046,
    state: "Kentucky",
    abbr: "KY",
    country: "USA",
  },
  {
    iin: 636007,
    state: "Louisiana",
    abbr: "LA",
    country: "USA",
  },
  {
    iin: 636041,
    state: "Maine",
    abbr: "ME",
    country: "USA",
  },
  {
    iin: 636048,
    state: "Manitoba",
    abbr: "MB",
    country: "CANADA",
  },
  {
    iin: 636003,
    state: "Maryland",
    abbr: "MD",
    country: "USA",
  },
  {
    iin: 636002,
    state: "Massachusetts",
    abbr: "MA",
    country: "USA",
  },
  {
    iin: 636032,
    state: "Michigan",
    abbr: "MI",
    country: "USA",
  },
  {
    iin: 636038,
    state: "Minnesota",
    abbr: "MN",
    country: "USA",
  },
  {
    iin: 636051,
    state: "Mississippi",
    abbr: "MS",
    country: "USA",
  },
  {
    iin: 636030,
    state: "Missouri",
    abbr: "MO",
    country: "USA",
  },
  {
    iin: 636008,
    state: "Montana",
    abbr: "MT",
    country: "USA",
  },
  {
    iin: 636054,
    state: "Nebraska",
    abbr: "NE",
    country: "USA",
  },
  {
    iin: 636049,
    state: "Nevada",
    abbr: "NV",
    country: "USA",
  },
  {
    iin: 636017,
    state: "New Brunswick",
    abbr: "NB",
    country: "CANADA",
  },
  {
    iin: 636039,
    state: "New Hampshire",
    abbr: "NH",
    country: "USA",
  },
  {
    iin: 636036,
    state: "New Jersey",
    abbr: "NJ",
    country: "USA",
  },
  {
    iin: 636009,
    state: "New Mexico",
    abbr: "NM",
    country: "USA",
  },
  {
    iin: 636001,
    state: "New York",
    abbr: "NY",
    country: "USA",
  },
  {
    iin: 636016,
    state: "Newfoundland and Labrador",
    abbr: "NL",
    country: "CANADA",
  },
  {
    iin: 636004,
    state: "North Carolina",
    abbr: "NC",
    country: "USA",
  },
  {
    iin: 636034,
    state: "North Dakota",
    abbr: "ND",
    country: "USA",
  },
  {
    iin: 604430,
    state: "Northern Marianna Islands",
    abbr: "MP",
    country: "USA",
  },
  {
    iin: 636013,
    state: "Nova Scotia",
    abbr: "NS",
    country: "CANADA",
  },
  {
    iin: 604433,
    state: "Nunavut",
    abbr: "NU",
    country: "CANADA",
  },
  {
    iin: 636023,
    state: "Ohio",
    abbr: "OH",
    country: "USA",
  },
  {
    iin: 636058,
    state: "Oklahoma",
    abbr: "OK",
    country: "USA",
  },
  {
    iin: 636012,
    state: "Ontario",
    abbr: "ON",
    country: "CANADA",
  },
  {
    iin: 636029,
    state: "Oregon",
    abbr: "OR",
    country: "USA",
  },
  {
    iin: 636025,
    state: "Pennsylvania",
    abbr: "PA",
    country: "USA",
  },
  {
    iin: 604426,
    state: "Prince Edward Island",
    abbr: "PE",
    country: "CANADA",
  },
  {
    iin: 604431,
    state: "Puerto Rico",
    abbr: "PR",
    country: "USA",
  },
  {
    iin: 604428,
    state: "Quebec",
    abbr: "PQ",
    country: "CANADA",
  },
  {
    iin: 636052,
    state: "Rhode Island",
    abbr: "RI",
    country: "USA",
  },
  {
    iin: 636044,
    state: "Saskatchewan",
    abbr: "SK",
    country: "CANADA",
  },
  {
    iin: 636005,
    state: "South Carolina",
    abbr: "SC",
    country: "USA",
  },
  {
    iin: 636042,
    state: "South Dakota",
    abbr: "SD",
    country: "USA",
  },
  {
    iin: 636027,
    state: "State Dept. (Diplomatic)",
    abbr: "",
    country: "USA",
  },
  {
    iin: 636053,
    state: "Tennessee",
    abbr: "TN",
    country: "USA",
  },
  {
    iin: 636015,
    state: "Texas",
    abbr: "TX",
    country: "USA",
  },
  {
    iin: 636040,
    state: "Utah",
    abbr: "UT",
    country: "USA",
  },
  {
    iin: 636024,
    state: "Vermont",
    abbr: "VT",
    country: "USA",
  },
  {
    iin: 636062,
    state: "Virgin Islands",
    abbr: "VI",
    country: "USA",
  },
  {
    iin: 636000,
    state: "Virginia",
    abbr: "VA",
    country: "USA",
  },
  {
    iin: 636045,
    state: "Washington",
    abbr: "WA",
    country: "USA",
  },
  {
    iin: 636061,
    state: "West Virginia",
    abbr: "WV",
    country: "USA",
  },
  {
    iin: 636031,
    state: "Wisconsin",
    abbr: "WI",
    country: "USA",
  },
  {
    iin: 636060,
    state: "Wyoming",
    abbr: "WY",
    country: "USA",
  },
  {
    iin: 604429,
    state: "Yukon",
    abbr: "YT",
    country: "CANADA",
  },
];
